<template>
  <ModalDialog
    v-model="visible"
    :title="title"
  >
    <template #default>
      <div>
        {{ paragraph1 }}
      </div>
      <br>
      <div>
        {{ paragraph2 }}
      </div>
    </template>
    <template #footer>
      <button
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        class="btn btn-primary"
        @click="emit('continue')"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>

<script lang="ts" setup>
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  import { computed } from 'vue';
  import resourceHelper from '@/Utils/resourceHelper';

  const props = withDefaults(defineProps<{ filesCount?: number }>(), { filesCount: 0 });
  const emit = defineEmits(['continue']);
  const visible = defineModel<boolean>({ default: false });

  const title = computed(() => {
    if (props.filesCount > 1) {
      return resourceHelper.getString('NonZipFilesWarningTitle', { filesCount: props.filesCount });
    }

    return resourceHelper.getString('NonZipFileWarningTitle');
  });

  const paragraph1 = computed(() => {
    if (props.filesCount > 1) {
      return resourceHelper.getString('NonZipFilesWarningPara1', { filesCount: props.filesCount });
    }

    return resourceHelper.getString('NonZipFileWarningPara1');
  });

  const paragraph2 = computed(() => {
    if (props.filesCount > 1) {
      return resourceHelper.getString('NonZipFilesWarningPara2', { filesCount: props.filesCount });
    }

    return resourceHelper.getString('NonZipFileWarningPara2');
  });
</script>
